<div class="grid justify-items-center mt-12">
    <div class="card grid justify-items-center w-xl" style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, color-mix(in srgb, var(--primary-color), transparent 60%) 10%, var(--surface-ground) 30%)">
        <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center"
            style="border-radius: 53px">
            <img class="mb-8" style="width:80px;height:80px" src="assets/runeandgear_logos/512hexagonlight.png" alt="Logo">
            <div class="w-full border-surface-300 dark:border-surface-500 border-b mb-8"></div>
            <span class="text-primary font-bold text-3xl">404</span>
            <h1 class="text-surface-900 dark:text-surface-0 font-bold text-3xl lg:text-5xl mb-2">Not Found</h1>
            <div class="text-surface-600 dark:text-surface-200 mb-4">Requested resource is not available.</div>
        </div>
    </div>
</div>